import React from 'react';
import PropTypes from 'prop-types';

import {Stack} from 'views/components';
import {translate} from 'views/module';

import {DraftTextField} from '../AgentJobDraftFields';
import {getRecipientListDetail} from '../../agentJobTypeUtils';

const EmailAgentJobDraft = (props) => {
  const {
    draftPayload,
    updatePayloadField,
  } = props;

  return (
    <Stack sx={{gap: 1.25}}>
      <DraftTextField
        label={translate('case.Detail.AgentJobs.Fields.To')}
        onChange={updatePayloadField('resourceRn')}
        value={draftPayload.resourceRn}
      />
      <DraftTextField
        label={translate('case.Detail.AgentJobs.Fields.Sender')}
        onChange={updatePayloadField('sender')}
        value={draftPayload.sender}
      />
      <DraftTextField
        label={translate('case.Detail.AgentJobs.Fields.Subject')}
        onChange={updatePayloadField('subject')}
        value={draftPayload.subject}
      />
      <DraftTextField
        label={translate('case.Detail.AgentJobs.Fields.Body')}
        multiline
        onChange={updatePayloadField('body')}
        value={draftPayload.body}
      />
    </Stack>
  );
};

EmailAgentJobDraft.propTypes = {
  draftPayload: PropTypes.object.isRequired,
  updatePayloadField: PropTypes.func.isRequired,
};

const buildPayload = ({draftPayload}) => {
  const nextPayload = {...draftPayload};

  if (!nextPayload.sender) {
    delete nextPayload.sender;
  }

  return nextPayload;
};

const getDraftBody = (job) => job.actionPayload?.body || '';

const getListDetail = (job, participantDetails) => {
  const payload = job.actionPayload || {};

  return [
    getRecipientListDetail(participantDetails, payload.resourceRn || job.resourceRn),
    payload.subject,
  ].filter(Boolean).join(' - ');
};

const getDraftSubtitle = (job) => job.actionPayload?.subject || translate('case.Detail.AgentJobs.ActionLabels.Email');

export default {
  Draft: React.memo(EmailAgentJobDraft),
  actionType: 'EMAIL',
  buildPayload,
  getDraftBody,
  getDraftSubtitle,
  getListDetail,
  label: translate('case.Detail.AgentJobs.ActionLabels.Email'),
};
